import { create } from "zustand"

import type { Category, CategorySortField, ProductCategoriesQuery, SortingOrder } from "@/graphql/codegen/graphql"
import { ProductCategoriesDocument } from "@/graphql/codegen/graphql"
import { type SearchFilters, createSearchStore } from "@/stores/createSearchStore"

export type ProductCategoriesSearchFilters = SearchFilters & {
  field?: CategorySortField
  order?: SortingOrder
}

const deduplicateData = (newData: Category[], existingData: Category[]): Category[] => {
  const uniqueIds = new Set(existingData.map((category) => category.categoryId))
  return [...existingData, ...newData.filter((category) => !uniqueIds.has(category.categoryId))]
}

export const useProductCategoriesSearchStore = create(
  createSearchStore<Category, ProductCategoriesSearchFilters, ProductCategoriesQuery>({
    documentNode: ProductCategoriesDocument,
    deduplicateData,
    getQueryInput: (filters: ProductCategoriesSearchFilters, offset: number, limit: number) => {
      const { field, order } = filters
      return {
        offset,
        limit,
        sort: { field, order },
      }
    },
    getQueryVariables: (queryInput) => ({ input: queryInput }),
    extractDataFromResponse: (data) => ({
      __typename: data.category.list.__typename,
      data:
        data?.category.list.__typename === "CategoryListSuccess" ? (data.category.list.categories as Category[]) : [],
      error: data?.category.list.__typename === "CategoryListFailure" ? data.category.list.error : undefined,
    }),
  })
)
